import { Link } from "react-router-dom";
import { SiteHeader, SiteFooter } from "../components/Site";
import { usePageMeta } from "../lib/usePageMeta";

const VIDEO_ID = "W1nnNNNwvaw";

export default function Film() {
  usePageMeta("film", "/film");
  return (
    <div className="min-h-screen bg-hf-cream">
      <SiteHeader />
      <main className="mx-auto max-w-5xl px-5 pb-20 pt-8 sm:px-8 sm:pt-14">
        <p className="hf-eyebrow">The film</p>
        <p data-testid="film-caption" className="mt-4 max-w-3xl font-heading text-3xl leading-snug sm:text-4xl">
          Where Handoff started: the brief that lets someone you trust step in.
        </p>
        <div data-testid="film-video" className="mt-10 overflow-hidden rounded-xl border-[1.5px] border-hf-line bg-hf-ink">
          <div className="relative aspect-video w-full">
            <iframe
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?rel=0`}
              title="Handoff film"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
          <Link to="/story" data-testid="film-read-story" className="hf-btn hf-btn-primary">Read the story</Link>
          <Link to="/demo" data-testid="film-see-demo" className="hf-btn hf-btn-ghost hf-arrow">See the demo</Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
